import "core-js/modules/es6.regexp.replace";
import _get from "lodash/get";
import _flatten from "lodash/flatten";
import _find from "lodash/find";

/**
 * Get entity embedded object by type and id.
 *
 * @param   {Object} entity   WordPress entity.
 * @param   {string} type     One of `EMBEDDED_OBJECT_TYPES` keys.
 * @param   {number} id       `id` of desired embedded object of type `type`.
 *
 * @return  {Object}          Embedded object.
 */
export var getEmbeddedObject = function getEmbeddedObject(entity, type, id) {
  var embeddedObjects = getEmbeddedObjectsByType(entity, type);
  return _find(embeddedObjects, {
    id: id
  }) || {};
};
/**
 * Get entity embedded objects by type.
 *
 * @param   {Object} entity   WordPress entity.
 * @param   {string} type     One of `EMBEDDED_OBJECT_TYPES` keys.
 *
 * @return  {Array}           Embedded objects.
 */

export var getEmbeddedObjectsByType = function getEmbeddedObjectsByType(entity, type) {
  // Embedded *term* data is different from other embedded data (e.g. user) in that
  // it is an array of arrays (one array per taxonomy type), and thus
  // requires hoisting all nested arrays.
  var embeddedObjects = _flatten(_get(entity, ['_embedded', type], []));

  return embeddedObjects;
};
/**
 * Get WordPress entity data object.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {Object}            Entity `nw_data` object.
 */

export var getNwData = function getNwData(entity) {
  return _get(entity, 'nw_data');
};
/**
 * Test whether a string ends with " - NerdWallet" suffix.
 * @private
 *
 * @param   {string} title      The title of the WordPress entity.
 * @return  {boolean}           Whether the title ends with "- NerdWallet".
 */

export var hasNwSuffix = function hasNwSuffix(title) {
  return / - NerdWallet$/.test(title);
};
/**
 * Remove the the " - NerdWallet" suffix from string.
 * @private
 *
 * @param   {string} title      The title of the WordPress entity.
 * @return  {string}            The title without the " - NerdWallet" suffix.
 */

export var stripNwSuffix = function stripNwSuffix(title) {
  return title && title.replace(/ - NerdWallet$/, '');
};